import { render, staticRenderFns } from "./BoxTable.vue?vue&type=template&id=d425de72&"
import script from "./BoxTable.vue?vue&type=script&lang=js&"
export * from "./BoxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports